/**
 * Compliance Mapper
 * Maps DTOs to Domain Entities
 */

import {
  ComplianceTypeEntity,
  MasterComplianceCalendarEntity,
  GroupedCalendarEntries,
} from "../../domain/entities";
import {
  ComplianceTypeDTO,
  MasterCalendarDTO,
  GroupedCalendarResponseDTO,
} from "../models/ComplianceDTOs";

export class ComplianceMapper {
  static toComplianceTypeEntity(dto: ComplianceTypeDTO): ComplianceTypeEntity {
    return {
      id: dto.id,
      compliance_type: dto.compliance_type,
      compliance_name: dto.compliance_name,
      authority: dto.authority,
      frequency: dto.frequency,
      description: dto.description,
      is_active: dto.is_active,
      display_order: dto.display_order,
      created_at: dto.created_at,
      updated_at: dto.updated_at,
      created_by: dto.created_by,
      updated_by: dto.updated_by,
    };
  }

  static toComplianceTypeEntityArray(dtos: ComplianceTypeDTO[]): ComplianceTypeEntity[] {
    return dtos.map((dto) => this.toComplianceTypeEntity(dto));
  }

  static toMasterCalendarEntity(dto: MasterCalendarDTO): MasterComplianceCalendarEntity {
    return {
      id: dto.id,
      compliance_type_id: dto.compliance_type_id,
      compliance_form_name: dto.compliance_form_name,
      period: dto.period,
      period_start_date: dto.period_start_date,
      period_end_date: dto.period_end_date,
      due_date: dto.due_date,
      authority: dto.authority,
      is_active: dto.is_active,
      created_at: dto.created_at,
      updated_at: dto.updated_at,
      created_by: dto.created_by,
      updated_by: dto.updated_by,
    };
  }

  static toMasterCalendarEntityArray(dtos: MasterCalendarDTO[]): MasterComplianceCalendarEntity[] {
    return dtos.map((dto) => this.toMasterCalendarEntity(dto));
  }

  static toGroupedCalendarEntries(response: GroupedCalendarResponseDTO): GroupedCalendarEntries {
    const grouped: GroupedCalendarEntries = {};
    
    Object.keys(response.data).forEach((typeId) => {
      const group = response.data[typeId];
      grouped[typeId] = {
        type: this.toComplianceTypeEntity(group.type),
        entries: this.toMasterCalendarEntityArray(group.entries),
      };
    });

    return grouped;
  }
}

